import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import { DOWNSCALE_FACTOR, downscale } from 'src/conf/scale';
import { Match2RewardsPanel } from 'src/game/minigame/match2-timestep/components/Match2RewardsPanel';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';

export class BuddiesSpeechBubble extends View {
  private image: ImageScaleView;
  private arrow: ImageScaleView;
  private text: LangBitmapFontTextView;
  private reward: Match2RewardsPanel;

  constructor(opts?: ViewOpts) {
    super({
      ...opts,
      canHandleEvents: false,
      width: 140,
      height: 176,
    });

    this.image = new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/popupBaking/speech_bubble.png',
      width: 140,
      height: 176,
      scaleMethod: '9slice',
      imgScale: DOWNSCALE_FACTOR,
      sourceSlices: {
        horizontal: { left: 80, right: 80 },
        vertical: { top: 80, bottom: 80 },
      },
      centerOnOrigin: true,
      canHandleEvents: false,
    });

    this.arrow = new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/popupBaking/speech_arrow.png',
      width: downscale(74),
      height: downscale(47),
      scaleMethod: 'contain',
      centerOnOrigin: true,
      canHandleEvents: false,
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 26,
      font: 'Body',
      color: '#603070',
      width: 320,
      height: 140,
      centerOnOrigin: true,
      y: -4,
    });

    this.reward = new Match2RewardsPanel({
      superview: this,
      width: 200,
      height: 130,
      noBg: true,
      centerOnOrigin: true,
    });
  }

  public async showAnimated() {
    animate.getGroup('buddiesSpeechBubble')?.clear();
    this.updateOpts({
      scale: 0,
      visible: true,
      anchorY: this.image.style.height / 2,
    });
    await animate(this, 'buddiesSpeechBubble')
      .now({ scale: 1 }, 500, animate.easeOutBack)
      .toPromise();
    await animate(this, 'buddiesSpeechBubble')
      .now({ scale: 1 }, 1000)
      .toPromise();
    await animate(this, 'buddiesSpeechBubble')
      .now({ scale: 0 }, 300, animate.easeInBack)
      .toPromise();
    this.updateOpts({ visible: false });
  }

  public setContent(
    content: string | Match2Reward[],
    opts?: { wide?: boolean },
  ) {
    this.reward.hide();
    this.text.hide();
    if (typeof content === 'string') {
      this.setTextContent(content, opts?.wide);
    } else {
      this.setRewardContent(content);
    }
  }

  private setTextContent(text: string, wide?: boolean) {
    this.text.show();
    this.text.localeText = () => text;
    this.updateBubbleSize({
      width: wide === undefined ? 250 : wide ? 290 : 220,
      height: 176,
    });
  }

  private setRewardContent(rewards: Match2Reward[]) {
    this.reward.show();
    this.reward.setRewards(rewards);
    this.updateBubbleSize({
      width: 176,
      height: 176,
    });
  }

  private updateBubbleSize(args: { width: number; height: number }) {
    this.image.updateOpts({
      width: args.width,
      height: args.height,
      centerOnOrigin: true,
    });
    this.arrow.updateOpts({
      x: this.image.style.x,
      y: this.image.style.y + this.image.style.height / 2,
    });
  }
}
